import { clickOutsideBind, clickOutsideUnbind } from 'frontcore/directives/click-outside/click-outside'
import { Directive } from 'vue'

const clickOutsideDirective: Directive = {
  mounted: clickOutsideBind,
  unmounted: clickOutsideUnbind,
}

export default clickOutsideDirective
